//Components
import { CircularProgress } from '@mui/material';

const LoadingProgress = () => {
    return (
        <CircularProgress variant='indeterminate' disableShrink sx={{ animationDuration: '1000ms', position: 'absolute', left: 10,  bottom: 10 }} size={50} thickness={4} color='error'/>
    )
}

export default LoadingProgress;